export default Object.freeze({
  ui: {
    classes: {
      hidden: 'is-hidden',
      nothing: 'is-nothing'
    }
  }
})
